import { ActionContext, ActionTree, Module } from 'vuex';
import { RootState } from '@/interface/store';
import { PurchaseOrder } from '@/interface/store/purchaseOrder';
import * as s_Interface from '@/interface/store/purchaseOrder';
import * as API from '@/api/purchaseOrder';

export const actions: ActionTree<s_Interface.PurchaseOrder, RootState> = {
  async getPoDetails(
    { commit }: ActionContext<PurchaseOrder, RootState>,
    { groupId, purchaseOrderId }: { groupId: string; purchaseOrderId: string }
  ) {
    try {
      const { data } = await API.getPoDetails(groupId, purchaseOrderId);
      commit('SET_PO_DETAILS', data);
    } catch (e) {
      throw e;
    }
  },
  async getPoAttachments(
    { commit }: ActionContext<s_Interface.PurchaseOrder, RootState>,
    { groupId, purchaseOrderId }: { groupId: string; purchaseOrderId: string }
  ) {
    try {
      const { data } = await API.getPoAttachments(groupId, purchaseOrderId);
      commit('SET_PO_ATTACHMENTS', data);
    } catch (e) {
      throw e;
    }
  },
  async deletePoAttachment(
    { commit },
    {
      groupId,
      purchaseOrderId,
      attachmentId,
    }: { groupId: string; purchaseOrderId: string; attachmentId: string }
  ) {
    try {
      await API.deletePoAttachment(groupId, purchaseOrderId, attachmentId);
    } catch (e) {
      throw e;
    }
  },
};
